import { PINCODES } from "./pincodes_data";

// India is a single timezone (IST, UTC+5:30) regardless of PIN code.
export const INDIA_TZ_OFFSET_MIN = 330;

export function findByPincode(code) {
  const key = String(code || "").trim();
  const entry = PINCODES[key];
  if (!entry) return null;
  const [name, lat, lon] = entry;
  return { name: `${name} (PIN ${key})`, lat, lon, tzOffsetMin: INDIA_TZ_OFFSET_MIN };
}
